import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';

interface TeamLeadContact {
  id: string;
  name: string;
  email: string;
  type: string;
  status: 'attending' | 'invited' | 'enrolled' | null;
}

interface TeamLeadContactsResponse {
  contacts: TeamLeadContact[];
}

export const useTeamLeadContactsQuery = (
  academyId: string,
  searchTerm?: string,
  trainingId?: string,
  trainingType?: string,
) =>
  useQuery({
    queryKey: ['team-lead-contacts', academyId, searchTerm],
    queryFn: async (): Promise<TeamLeadContact[]> => {
      try {
        const params = new URLSearchParams();
        if (searchTerm) {
          params.append('search', searchTerm);
        }
        if (trainingId) {
          params.append('training_id', trainingId);
        }
        if (trainingType) {
          params.append('training_type', trainingType);
        }

        const response = await FetchPromise.get(`academies/${academyId}/team_lead_contacts?${params.toString()}`);

        const data: TeamLeadContactsResponse = response;
        return data.contacts;
      } catch (error) {
        console.error('Error fetching team lead contacts:', error);
        throw error;
      }
    },
    enabled: !!academyId,
  });
